var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    fill: "currentColor",
    className: "CodeCard__CodeCopy-sc-6satcu-3 gtllrM",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.0003C5.04167 14.0003 4.64944 13.8373 4.32333 13.5112C3.99667 13.1845 3.83333 12.792 3.83333 12.3337V2.33366C3.83333 1.87533 3.99667 1.48283 4.32333 1.15616C4.64944 0.830048 5.04167 0.666992 5.5 0.666992H13C13.4583 0.666992 13.8508 0.830048 14.1775 1.15616C14.5036 1.48283 14.6667 1.87533 14.6667 2.33366V12.3337C14.6667 12.792 14.5036 13.1845 14.1775 13.5112C13.8508 13.8373 13.4583 14.0003 13 14.0003H5.5ZM5.5 12.3337H13V2.33366H5.5V12.3337ZM2.16667 17.3337C1.70833 17.3337 1.31583 17.1706 0.989167 16.8445C0.663055 16.5178 0.5 16.1253 0.5 15.667V4.00033H2.16667V15.667H11.3333V17.3337H2.16667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6f9f8aaba93c4b10474d2e2e52f1c01a.svg";
export { ForwardRef as ReactComponent };